import axios from 'axios'
import { API_PATH } from '../../constant/urlConstant'
import { handleAPIError } from '../common/errorHandler'
import { baseUrl } from '../PostAPI'
// import { USER_ROLE } from "../../constant/actionTypes/role";

export const fetchGatNoList = async (payload) => {
  let url
  if (!payload) {
    url = `${baseUrl}${API_PATH.GATNO.FETCH}`
  } else {
    url = `${baseUrl}${API_PATH.GATNO.FETCH_BY_VILLAGE}/${payload}`
  }
  // const token = localStorage.getItem("token");
  try {
    const result = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json'
        // Authorization: `Bearer ${token}`,
      }
    })
    if (result.data.error || result.status !== 200) {
      return handleAPIError(result.data.detail)
    }
    return result.data
  } catch (error) {
    console.error(error)
    return handleAPIError(error)
  }
}

export const fetchGatNoRecord = async (payload) => {
  const GatNo=payload?.gatNo ?? payload ?? ''
  const PlanId=payload?.planId ?? ''
  
  
  const url = PlanId ? 
  `${baseUrl}${API_PATH.GATNO.FETCH}/${GatNo}?planId=${PlanId}` : 
  `${baseUrl}${API_PATH.GATNO.FETCH}/${GatNo}`;


  const token = localStorage.getItem('token')
  try {
    const result = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    if (result?.data?.error || result.status !== 200) {
      return handleAPIError(result.data.detail)
    }
    return result.data
  } catch (error) {
    console.error(error)
    return handleAPIError(error?.response?.data)
  }
}

export const fetchGatNoRecordByUrl = async (payload) => {
  const url = `${baseUrl}${API_PATH.GATNO.FETCH_BY_URL}?url=${payload}`
  const token = localStorage.getItem('token')
  try {
    const result = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    if (result?.data?.error || result.status !== 200) {
      return handleAPIError(result.data.detail)
    }
    return result.data
  } catch (error) {
    console.error(error)
    return handleAPIError(error?.response?.data?.message ?? '')
  }
}

export const createGatNoRecord = async (payload) => {
  const url = `${baseUrl}${API_PATH.GATNO.ADD}`
  const token = localStorage.getItem('token')
  try {
    const result = await axios.post(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    })
    if (result?.data?.error || result.status !== 201) {
      return handleAPIError(result.data.detail)
    }
    return result.data
  } catch (error) {
    return handleAPIError(error.response.data.detail)
  }
}

export const updateGatNoRecord = async (payload, id) => {
  const url = `${baseUrl}${API_PATH.GATNO.EDIT}/${id}`
  const token = localStorage.getItem('token')
  try {
    const result = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    })
    if (result?.data?.error || result.status !== 200) {
      return handleAPIError(result.data.detail)
    }
    return result.data
  } catch (error) {
    return handleAPIError(error.response.data.detail)
  }
}

export const deleteGatNo = async (gatNoId) => {
  const url = `${baseUrl}${API_PATH.GATNO.DELETE}/${gatNoId}`
  const token = localStorage.getItem('token')
  try {
    const result = await axios.delete(url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    if (result?.data?.error || result.status !== 204) {
      return handleAPIError(result.data.detail)
    }
    return result.data
  } catch (error) {
    console.error(error)
    return handleAPIError(error.response.data.detail)
  }
}

export const getGatNoCount = async (role, payload) => {
  let url = ''
  // if(USER_ROLE.ADMIN === role){
  url = `${baseUrl}${API_PATH.GATNO.COUNT}?tenantId.equals=${payload}`
  // }else{
  //   url = `${baseUrl}${API_PATH.GATNO.COUNT}?userId.equals=${payload}`;
  // }

  const token = localStorage.getItem('token')
  try {
    const result = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    if (result.status !== 200) {
      return handleAPIError(result?.data?.detail ?? '')
    }
    return result.data
  } catch (error) {
    console.error(error)
    return handleAPIError(error.response.data.detail)
  }
}
